import jsonApiClient from './jsonApiClient'

export function apiErrorsToFormik(e) {
  let formikErrors = {}
  Object.keys(e).map(field => formikErrors[field] = e[field].detail.replace(`${field} - `, ''))
  return formikErrors
}

export async function fetchRecordBySlug(recordType, slug) {
  const jsonApi = jsonApiClient()
  const { data, errors } = await jsonApi.findAll(recordType, {
    filter: {
      slug
    }
  })

  if(errors) return errors
  if(data) return data[0]
}
